<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-template`]" width="1em" height="1em" v-bind="$attrs"><path d="M18.1247 12.5254C18.1247 14.4851 18.1252 15.4653 17.7438 16.2139C17.4083 16.8724 16.8721 17.4076 16.2136 17.7432C15.4649 18.1245 14.4851 18.125 12.5251 18.125H8.55048V8.68164H18.1247V12.5254ZM6.55048 8.68164V18.1201C5.18595 18.1108 4.40631 18.0593 3.78583 17.7432C3.1274 17.4076 2.59204 16.8723 2.25653 16.2139C1.87511 15.4652 1.87469 14.4853 1.87469 12.5254V8.68164H6.55048ZM12.5251 1.875C14.4851 1.875 15.4649 1.87545 16.2136 2.25684C16.8721 2.59239 17.4083 3.12757 17.7438 3.78613C18.0699 4.4262 18.1139 5.23554 18.1208 6.68164H1.8786C1.88546 5.23542 1.93041 4.42622 2.25653 3.78613C2.59204 3.12767 3.1274 2.5924 3.78583 2.25684C4.53452 1.87536 5.5151 1.875 7.47528 1.875H12.5251Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillTemplate',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
